import { IPageData,  IFilterTag, IYear, FilterType, IRelatedLinkProps, IFilterTagGroup, IFilterTagFromAPI } from "@/types/types";
import { IFilterTags, IFilterTag as IFilterTagData } from "@/types/IFilterTags";
import { ISubContentPage } from "@/types/ISubContentPage";
import { IVacanciesPage } from "@/types/IVacanciesPage";
import { INewsPage } from "@/types/INewsPage";
import { IFrontPage } from "@/types/IFrontPage";
import { INavAndFooter, getNavAndFooter } from "./getComponent";
import { INewsArticlePage } from "@/types/INewsArticlePage";
import { IContentPage} from "@/types/IContentPage";
import { IInsightsOverviewPage } from "@/types/IInsightsOverviewPage";
import { IInsightPage } from "@/types/IInsightPage";
import { IProjectsPage } from "@/types/IProjectsPage";
import { IProjectArticlePage } from "@/types/IProjectArticlePage";
import { IOfficePage, IOffices } from "@/types/IOfficePage";
import { IErrorPage } from "@/types/IErrorPage";
import { IGroupSummation, ISearchResponse, ISearchSuggestion } from "@/types/ISearchResults";
import { ISearchResultsData } from "@/types/components/ISearchResultData";
import {IVacancyResultData} from "@/types/components/IVacancyResultData";
import { IVacancyListItem } from "@/types/IVacancyListItem";
import { IVacancyPage } from "@/types/IVacancyPage";
import { IVacancy } from "@/types/IVacancy";
import { IVacancyTags } from "@/types/components/IVacancyTags";
import {INewsletterPage} from "@/types/INewsletterPage";
import { ICookieinformationPage } from "@/types/ICookieinformationPage";
import {getAnkiroBaseUrl} from "./helper";


async function get<R> (url: string, name: string, isPreview = false, withCredentials = false): Promise<R> {
const root = document.documentElement.dataset.root?.toLowerCase().replace(' ','-');
 const logTag = `GET - ${name || url}`
 const pageKey = document.documentElement.dataset.id; 
 try {   
  const response = await fetch(url, {
   method: 'GET',
   credentials: withCredentials ? 'include' : 'same-origin',
   headers: {
     'Api-Key': 'simsalabim',
     'Preview': isPreview ? 'true' : 'false',
     'Page-Key': `${pageKey}`,
     'Site-Key':`${pageKey}`,
     'Start-Item': `${root}`
    },
  });
  
  if (!response.ok) {
   throw new Error(`HTTP error! status: ${response.status}`);
  }
  const respData = (await response.json()) as R;   
  return respData;
 } catch (err) {
  if (err instanceof Error) {
   
  } else {
   
  }
  throw err;
 }
}

export const getPage = async (path?: string, isPreview?: boolean): Promise<IFrontPage | INewsArticlePage | IInsightsOverviewPage | IProjectArticlePage | IProjectsPage | IContentPage | IInsightPage | IOfficePage | IErrorPage | INewsletterPage | ICookieinformationPage> => {
  path = !path?.startsWith("/home") ? `/home/${path}` : path
  const url = path ? `/umbraco/delivery/api/v2/content/item/${path}?expand=properties[$all[$all[$all]]]`: '/umbraco/delivery/api/v2/content/item/?expand=properties[$all[$all[$all]]]'
  const data: IFrontPage | INewsArticlePage | IInsightsOverviewPage | IProjectArticlePage | IProjectsPage | IContentPage | IOfficePage | IErrorPage | INewsletterPage | ICookieinformationPage =  await get(url, "Page", isPreview)
  return data
}

export const getPageByID = async (path?: string, isPreview?: boolean): Promise<IFrontPage | INewsArticlePage | IInsightsOverviewPage | IProjectArticlePage | IProjectsPage | IContentPage | IInsightPage | IOfficePage | IErrorPage | INewsletterPage | ICookieinformationPage> => {
  const url = path ? `/umbraco/delivery/api/v2/content/item/${path}?expand=properties[$all[$all[$all]]]`: '/umbraco/delivery/api/v2/content/item/?expand=properties[$all[$all[$all]]]'
  const data: IFrontPage | INewsArticlePage | IInsightsOverviewPage | IProjectArticlePage | IProjectsPage | IContentPage | IOfficePage | IErrorPage | INewsletterPage | ICookieinformationPage =  await get(url, "Page", isPreview)
  return data
}

export const getVacancyViewPage = async (isPreview?:boolean): Promise<string> => {
  const url= `/umbraco/delivery/api/v2/content?filter=contentType:vacancy&skip=0&take=1`
  const data: IFilterTags =  await get(url, "Vacancy Page", isPreview)
  return  data.items[0].route.path
}

export const getNavigationAndFooter = async (id: string): Promise<INavAndFooter> => {
  const url = `/umbraco/delivery/api/v2/content/item/${id}`
  const data: IFrontPage | INewsArticlePage | INewsPage  =  await get(url, "Navigation and Footer ")
  const navigationAndFooter =  getNavAndFooter(data.properties)
  return navigationAndFooter
}

export const getPageFamily = async (id: string): Promise<IPageData> => {  
  const url = `/api/path/GetPageFamily?id=${id}`
  const data: IPageData  =  await get(url, `Family from ID`) 
  return data
}

export const getPageWithChildren = async (page: string, subPage: string): Promise<IPageData> => {  
  const url = `/api/path/GetChildren?path=/home/${page}/${subPage}`
  
  const data: IPageData  =  await get(url, `${page}/${subPage}`) 
  return data
}

export const getPathFromID = async (id: Number): Promise<String[]> => {
  const url = `/api/path/GetPathFromID?id=${id}`
  const data: string[]  =  await get(url, 'Path from ID') 
  return data  
}

export const getFilterTags = async (contentType: FilterType ): Promise<IFilterTag[]> => {
  const url = `/umbraco/delivery/api/v2/content?filter=contentType:${contentType}&sort=sortOrder:asc`
 const data: IFilterTags =  await get(url, 'News tags')

 const tags = data.items.map((tag) => {
  return {
   id: tag.id,
   title: tag.properties.title,
   sectorToggle: tag.properties.sectorToggle,
   contentType: tag.contentType as FilterType,
  }
 })
  return tags
}
export const getSectorTags = async (): Promise<IFilterTag[]> => {
  const url = `/umbraco/delivery/api/v2/content?filter=contentType:sectorTag&sort=sortOrder:asc`
  const data: IFilterTags =  await get(url, 'Sector tags')
  const tags = data.items.map((tag) => {
  return {
   id: tag.id,
   title: tag.properties.title,
   sectorToggle: tag.properties.sectorToggle,
   contentType: tag.contentType as FilterType,
  }
 })
  return tags as IFilterTag[]
}

export const getYearsFilter = async (id: string, regionId: string, mockData: boolean = false): Promise<IYear[]> => {
  const url = `/api/news/GetYears?newsCategoryId=${id}&newsRegion=${regionId}`
  
  if (mockData) {
    return await Promise.resolve([]);
 }
 const data: IYear[] =  await get(url, 'Year filter')
  
 return data
}

export const getNews = async (pageId: string, regionId: string, pageNumber: number, pageSize: number, yearId?: string, mockData: boolean = false): Promise<INewsPage[]> => {
  const url = yearId ? `/api/news/GetNews?id=${pageId}&region=${regionId}&year=${yearId}&pageNumber=${pageNumber}&pageSize=${pageSize}` : `/api/news/GetNews?id=${pageId}&region=${regionId}&pageNumber=${pageNumber}&pageSize=${pageSize}`  
  if (mockData) {
    return await [];
  }
  const data: INewsPage[] =  await get(url, 'Get News Articles')  
  return data
}


export const getRelatedItemsLink = async (type: string): Promise<IRelatedLinkProps> => {
  const url = `/api/${type}/GetPageTextAndSeeAllLink/`
  const data: IRelatedLinkProps =  await get(url, 'Related News Links')
  return data
}

export const getAllInsights = async (pageNumber: number = 1, pageSize: number = 10) : Promise<IInsightPage[]> => {
  const url = `/api/insight/GetAllInsights?pageNumber=${pageNumber}&pageSize=${pageSize}`
  const data: IInsightPage[] =  await get(url, 'Get All Insights')
  return data
}

export const getInsights = async (guid: string, sectorguid: string, pageNumber: number = 1, pageSize: number = 10) : Promise<IInsightPage[]> => {
  const url = `/api/insight/GetInsights?insightsCategoryId=${guid}&tag=${sectorguid}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  const data: IInsightPage[] =  await get(url, 'Get Insights')
  return data
}

export const getRelatedInsights = async (sectorGUID: string, GUID: string): Promise<IInsightPage[]> => {
  const url = `/api/insight/GetRelatedInsights?sectorGuid=${sectorGUID}&currentPage=${GUID}`
  const data: IInsightPage[] =  await get(url, 'Related Insights')
  return data
}

// PROJECTS
export const getAllProjects = async (pageNumber: number = 1, pageSize: number = 10) : Promise<IProjectArticlePage[]> => {
  const url = `/api/project/GetAllProjects?pageNumber=${pageNumber}&pageSize=${pageSize}`
  const data: IProjectArticlePage[] =  await get(url, 'Get All Projects')
  return data
}
export const getProjects = async (guid: string, sectorguid: string, pageNumber: number = 1, pageSize: number = 10) : Promise<IProjectArticlePage[]> => {
  const url = `/api/project/GetProjects?projectsCategoryId=${guid}&tag=${sectorguid}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  const data: IProjectArticlePage[] =  await get(url, 'Get Projects')
  return data
}

export const getRelatedProjects = async (sectorGUID: string, GUID: string): Promise< IProjectArticlePage[]> => {
  const url = `/api/project/GetRelatedProjects?sectorGuid=${sectorGUID}&currentPage=${GUID}`
  const data:  IProjectArticlePage[] =  await get(url, 'Related Projects')
  return data
}

export const getSubContentPage = async (pageId: string, isPreview?: boolean): Promise<ISubContentPage> => {
  const url = `/umbraco/delivery/api/v2/content/item/${pageId}?expand=properties[$all[$all[$all]]] ` 
  const data: ISubContentPage =  await get(url, 'Subcontent Page', isPreview)
  return data
}

export const getVacanciesPage = async (pageId: string, isPreview?: boolean): Promise<IVacanciesPage> => {
  const url = `/umbraco/delivery/api/v2/content/item/${pageId}?expand=properties[$all[$all[$all]]] `   
  const data: IVacanciesPage =  await get(url, 'Subcontent Page', isPreview)
  return data
}

export const getVacancyPage = async (pageId: string, isPreview?: boolean): Promise<IVacancyPage> => {
  const url = `/umbraco/delivery/api/v2/content/item/${pageId}?expand=properties[$all[$all[$all]]] `   
  const data: IVacancyPage =  await get(url, 'Vacancy Page', isPreview)
  return data
}

export const getVacancyById = async (id: string, isPreview?: boolean): Promise<any> => {
  const url = `/api/vacancies/GetJobById/${id}`   
  const data: IVacancy =  await get(url, 'Vacancy Page', isPreview)  
  return data
}

export const getRelatedArticles = async (regionGUID: string, GUID: string): Promise<INewsPage[]> => {
  const url = `/api/news/GetRelatedArticles?regionGuid=${regionGUID}&currentPage=${GUID}`
  const data: INewsPage[] =  await get(url, 'Related Articles')
  return data
}

export const getFilteredInsights = async (guid: string, sectorguid: string, pageNumber: number = 1, pageSize: number = 10 ): Promise<any> => {
  const url = `/api/insight/GetInsights?insightsCategoryId=${guid}&tag=${sectorguid}&${pageNumber}=1&pageSize=${pageSize}` 
  const data: ISubContentPage =  await get(url, 'Insights Overview')
  return data
}

export const getOfficeLocations = async (): Promise<IFilterTag[]> => {
  const url = `/api/office/GetAllOfficeRegions`
  const data: IFilterTagData[] =  await get(url, 'Office Locations')
  const tags = data.map((tag) => {
    return {
     id: tag.id,
     title: tag.name,
     contentType: tag.contentType as FilterType,
    }
   })
    return tags
}

export const getOfficeLocationsAPI = async (): Promise<IFilterTag[]> => {
  const url = `/umbraco/delivery/api/v2/content?filter=contentType:officeRegion&sort=sortOrder:asc`;
  const response = await get<{items: any[] }>(url, 'Office Locations');
  const tags: IFilterTag[] = response.items.map((item) => {
    return {
      id: item.id,
      title: item.name,
      contentType: item.contentType as FilterType,
    }
  });
  return tags;
}

export const getOfficeByLocation = async (guid: string): Promise<IOffices> => {
  const url = `/api/office/GetOfficeByRegion?OfficeRegionGuid=${guid}`
  const data: IOffices =  await get(url, 'Offices')
  return data
}

export const getTranslations = async (key: string): Promise<string> => {
  const url = `/api/dictionary/GetDictionaryValue?key=${key}&language=en-us`
  try {
    const response = await fetch(url, {
     method: 'GET',
     headers: {
     },
    });
    if (!response.ok) {
     throw new Error(`HTTP error! status: ${response.status}`);
    }
    const respData = await response.text();
    return respData as string;
   } catch (err) {
    throw err;
   }
}

export const getVacancyTags = async (): Promise<IVacancyTags> => {
  const url = '/umbraco/delivery/api/v2/content?filter=contentType%3AvacancyTag'
  const data: IVacancyTags =  await get(url, 'Vacancy tags')
  return data
}

export const getVacanciesFromAnkiro = async (type: string = "", q: string, startIndex: number = 0, sortOrder: string = "sort-desc", country: string | string[] = "", jobcategory: string = "", location: string | string[] =""): Promise<IVacancyResultData> => {

  let baseUrl = '' 
  let countryParam = ''
  let locationParam = ''
  let jobcategoryParam = ''
  switch(type){
    case 'noDeadline':
      baseUrl = 'https://cowi.ankiro.dk/Rest/Cowi-vacancies-Evergreen/Search/?Category=Open%20vacancies'
      break;
    case 'earlyCareers':
      const data = await getVacancyTags()
      const tags = data.items.map((tag) => {
        return`&custReqType=${tag.properties.title.replace(/\s/g, '%20')}`
      }).join('');
      baseUrl = `https://cowi.ankiro.dk/Rest/Cowi-vacancies-Early-career/Search/?Category=Open%20vacancies`
      break;
    default:
      baseUrl = getAnkiroBaseUrl()
    }

  if (Array.isArray(jobcategory)){
    jobcategory.forEach((jobcategory) =>{
      jobcategoryParam += `&JobCategory=${jobcategory}`
    })
  }else{
    jobcategoryParam = `&JobCategory=${jobcategory}`
  }  
  
  //check if country is a string or a string[]
  if(Array.isArray(country)){
    //loop through the array and add each country the countryParam string with '&Countries='
    country.forEach((country) => {
      countryParam += `&Countries=${country}`
    })
  }else{    
    countryParam = `&Countries=${country}`
  }

  if (Array.isArray(location)){
    location.forEach((loc) => {
      locationParam += `&Locations=${loc}`
    })
  }else{
    locationParam = `&Locations=${location}`
  }
  
  const url = q && q != "*" ? `${baseUrl}&q=${q}&startIndex=${startIndex}&${sortOrder}=ClosingDate${countryParam}${jobcategoryParam}${locationParam}`: `${baseUrl}&q=%2A&startIndex=${startIndex}&${sortOrder}=ClosingDate${countryParam}${jobcategoryParam}${locationParam}`

  
   try {
    const response = await fetch(url, {
     method: 'GET',
     headers: {},
    });
    if (!response.ok) {
     throw new Error(`HTTP error! status: ${response.status}`);
    }

    const respData: ISearchResponse = (await response.json());
    if(!respData.Documents) {
      return {
        totalCount: 0,
        results: []
      }
    }

     const results = respData.Documents.map((doc) => {

      let countryArray = []
      countryArray = doc.Properties.find((prop) => prop.Name === 'Countries')?.ValueList ?? []
      //Make a list of countries from the countryArray
      let countryList = ""
      if(countryArray){
        countryArray.forEach((country) => {
          if (countryList.length > 0){
            countryList += ", "
          }
          countryList += country
        })
      }

      let locationArray = []
      locationArray = doc.Properties.find((prop) => prop.Name === 'Locations')?.ValueList ?? []

      let locationList = ""
      if(locationArray){
        locationArray.forEach((location) => {
           //add a , before location if not the first in loop
          if(locationList.length >
            0){
            locationList += ", "
          }
          locationList += location
          
        })
      }

      return {
        title: doc.Properties.find((prop) => prop.Name === 'Title')?.Value,
        content: doc.Properties.find((prop) => prop.Name === 'Content')?.ValueMarkup,
        url: doc.FriendlyUri,
        jobcategory: doc.Properties.find((prop) => prop.Name === 'JobCategory')?.Value,
        // locations: doc.Properties.find((prop) => prop.Name === 'Locations')?.Value,
        locations: locationList,
        country: doc.Properties.find((prop) => prop.Name === 'Country')?.Value,
        //countries: doc.Properties.find((prop) => prop.Name === 'Countries')?.ValueList?.[0],
        countries: countryList,
        postingStatus: doc.Properties.find((prop) => prop.Name === 'PostingStatus')?.Value,
        closingDate: doc.Properties.find((prop) => prop.Name === 'ClosingDate')?.Value,
        publishDate: doc.Properties.find((prop) => prop.Name === 'PublishDate')?.Value,
        company: doc.Properties.find((prop) => prop.Name === 'Company')?.Value,
        reqId: doc.Properties.find((prop) => prop.Name === 'ReqId')?.Value,
        custReqType: doc.Properties.find((prop) => prop.Name === 'CustReqType')?.Value
        } 
      }
    )
    
    const searchResultsData = {
      totalCount: respData.TotalResults,      
      results,
    }

    return searchResultsData

    } catch (err) {
      throw err;
    }
}


export const getSearchResult = async (q: string, path:string, startIndex: number = 0, category?: string): Promise<ISearchResultsData> => {
  //

  const baseUrl = path.toLowerCase() === "cowi" ?'https://cowi.ankiro.dk/Rest/COWI.com/Search':'https://cowi.ankiro.dk/Rest/COWIFonden.com/Search';
  //
  const url = category ? `${baseUrl}?q=${q}&Category=${category}&startIndex=${startIndex}`: q ? `${baseUrl}?q=${q}&startIndex=${startIndex}`: `${baseUrl}`
  try {
    const response = await fetch(url, {
     method: 'GET',
     headers: {},
    });
    if (!response.ok) {
     throw new Error(`HTTP error! status: ${response.status}`);
    }

    const respData: ISearchResponse = (await response.json());
    if(!respData.Documents) {
      return {
        totalCount: "0",
        categories: [],
        results: []
      }
    }
     const results = respData.Documents.map((doc) => {
      return {
        title: doc.Properties.find((prop) => prop.Name === 'Title')?.Value,
        category: doc.Properties.find((prop) => prop.Name === 'Category')?.Value,
        content: doc.Properties.find((prop) => prop.Name === 'Content')?.ValueMarkup,
        url: doc.FriendlyUri,
        } 
      }
    )
    const categories = respData.GroupSummations.reduce((acc: any[], val: IGroupSummation) => {
      const groupCategories = val.Groups.map(group => ({
        title: group.Value,
        totalCount: group.Count
      }));
      return acc.concat(groupCategories);
    }, []);
    
    const searchResultsData = {
      totalCount: respData.TotalResults,
      categories: categories,
      results
    }
    return searchResultsData

    } catch (err) {
      throw err;
    }
}

export const getSearchSuggestions = async (q: string): Promise<any> => {
  const url = `https://cowi.ankiro.dk/Rest/COWI.com/TypeAhead?q=${q}`
  try {
    const response = await fetch(url, {
     method: 'GET',
     headers: {},
    });
    if (!response.ok) {
     throw new Error(`HTTP error! status: ${response.status}`);
    }


    const respData: ISearchSuggestion[] = (await response.json());
    
    const suggestions = respData.reduce((acc: string[], val: ISearchSuggestion) => {
      acc.push(val.Term);
      return acc;
    }, []);
    
    return suggestions

    } catch (err) {
      throw err;
    }
}

//VACANCIES
/**
 * Fetches a list of job vacancies.
 * @returns A promise that resolves with an array of IVacancyListItem.
 */
export const getVacancies = async () : Promise<IVacancyListItem[]> =>{
  const url = `/api/vacancies/GetJobs`
  const data: IVacancyListItem[] =  await get(url, 'Vacancy Page')
  return data
}

export const getVacanciesByQuery = async (query: string) : Promise<IVacancyListItem[]> =>{
  const url = `/api/vacancies/SearchJobs/${query}`
  const data: IVacancyListItem[] =  await get(url, 'Vacancy Page')
  return data
}

export const getVacanciesByCategory = async (category: string) : Promise<IVacancyListItem[]> =>{
  const url = `/api/vacancies/GetJobByCategory/${category}`
  const data: IVacancyListItem[] =  await get(url, 'Vacancy Page')
  return data 
}

export const getVacanciesByLocation = async (location: string) : Promise<IVacancyListItem[]> =>{
  const url = `/api/vacancies/GetJobByLocation/${location}`
  const data: IVacancyListItem[] =  await get(url, 'Vacancy Page')
  return data 
}

export const getVacanciesByCountry = async (country: string) : Promise<IVacancyListItem[]> =>{
  const url = `/api/vacancies/GetJobByCountry/${country}`
  const data: IVacancyListItem[] =  await get(url, 'Vacancy Page')
  return data 
}

export const getVacancyCategories = async() : Promise<string[] | null> => {
  const url = `/api/vacancies/GetCategories`
  const data: string[] =  await get(url, 'Location list')
  return data
}

export const getVacancyLocations = async() : Promise<string[] | null> => {
  const url = `/api/vacancies/GetLocations`
  const data: string[] =  await get(url, 'Location list')
  return data
}

export const getVacencyCountries = async() : Promise<string[] | null> => {
  const url = `/api/vacancies/GetCountries`   
  const data: string[] =  await get(url, 'Country list')
  return data
}

export const getSuggestions = async() : Promise<string[] | null> => {
  const url = `http://localhost:3000/cowi/countries`
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {"Authorization": "Basic aGVhZHRlc3Q6aGVhZHRlc3Q="},
    });
    if (!response.ok) {
     throw new Error(`HTTP error! status: ${response.status}`);
    }
    const respData: string[] = await response.json();    
    return respData;
  } catch (err) {
    
    throw err;
  }
}


